// extracted by mini-css-extract-plugin
export default {"storyDetail":"c-r_hm","storyDetail__photo":"c-r_hn"};